/**
 *
 * @module bookmarkExtensions
 *
 */

import Check from 'check-types';
import Services from './../../services/entry';
import BookmarksQuery from './bookmarksQuery';

const GraphQlBuilder = Services.Content.GraphQlBuilder;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    instanceStrict,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class BookmarkExtensions
 *
 */
export default (ContentManager) => {

    /**
     *
     * @access public
     * @param {GraphQlBuilder} query Query to be used to retrieve bookmarks.
     * @param {String} [contentTransactionId] - An application developer-provided value to be included with the HTTP
     * request as the value of the `X-Content-Transaction-ID` header.
     * @desc Queries the bookmark service.
     * @returns {Promise<Object>} The GraphQL JSON returned from the bookmark service.
     *
     */
    ContentManager.prototype.getBookmarks = function (query, contentTransactionId) {

        const errorMessage = {
            method: 'BookmarkExtensions.getBookmarks(query, contentTransactionId)',
            get query() {
                return `${this.method} needs GraphQlBuilder instance`;
            },
            get contentTransactionId() {
                return `${this.method} contentTransactionId should be a String with length`;
            }
        };

        instanceStrict(query, GraphQlBuilder, errorMessage.query, InvalidArgumentException);

        if (Check.assigned(contentTransactionId)) {
            nonEmptyString(contentTransactionId, errorMessage.contentTransactionId, InvalidArgumentException);
        }

        const bookmarkQuery = new BookmarksQuery(query);

        return this.query({
            query: bookmarkQuery,
            contentTransactionId
        });

    };

};



// WEBPACK FOOTER //
// ./src/content/bookmarks/bookmarkExtensions.js